import { AbstractControl } from '../models/AbstractControl';
import { FormControl } from '../models/FormControl';

export type Validator = (control: AbstractControl<unknown>) => ValidationResult;

interface ValidationResult {
  isValid: boolean;
  /**
   * Should contain the names of the validation functions that return invalid,
   * e.g. 'checkValidEmail' or whatever that should make it easy to identity the validation function,
   * mapped to the error message for the corresponding validation function
   */
  failedValidations: Record<string, string>;
}

/**
 * A utility class that provides different validation logs
 */
export class Validators {

  /**
   * Return a validation function checking if form value is a valid email
   *
   * @param controlLabel The name of the form field to which the validator is applied
   * @param errorMessage The error message that will be displayed when the validation fails
   * @returns
   */
  static checkValidEmail(): Validator {
    const emailRegex = /^\w+[\w\d_.]*@\w+\.\w+$/;
    return control => {
      return {
        isValid: emailRegex.test(String(control.getValue())),
        failedValidations: {
          checkValidEmail: 'Email is not valid'
        }
      };
    };
  }

  static checkNotEmpty(): Validator {
    return control => {
      const value = control.getValue();
      return {
        isValid: value !== null && value !== undefined && String(value).trim() !== '',
        failedValidations: {
          checkNotEmpty: 'This field is required'
        }
      };
    };
  }


  static checkPassword(): Validator {
    return (control: FormControl<string>) => {
      const value = String(control.getValue());
      const failedValidations = {} as Record<string, string>;
      if (value.length < 8) {
        failedValidations.checkPasswordLength = 'Password must be between 8 characters or longer';
      }
      if (value.includes(' ')) {
        failedValidations.checkPasswordSpecialCharacters = 'Password may not contain spaces';
      }
      return {
        isValid: Object.entries(failedValidations).length === 0,
        failedValidations
      };
    };
  }

  static checkConfirmedPassword(password: FormControl<string>): Validator {
    return (control: FormControl<string>) => {
      return {
        isValid: (control.getValue() === password.getValue()),
        failedValidations: {
          checkConfirmedPassword: 'Passwords must match'
        }
      };
    };
  }

}
